//import Libraries
import React from 'react';
import { Link } from 'react-router-dom';

//import Components


//import Style classes
import './SubNavigation.css'

const subNavigation = (props) => {

    let subButtons = props.data.subDepartments.map((obj, idx)=>{
    let addClass = props.page == idx ? "active" : "";
        return (
            <Link to={"/"+props.type+"/"+idx} key={idx}>
                <div className={"SubButton "+addClass}>
                    <p>{obj.name[props.lang]}</p>
                </div>
            </Link>
        )
    });

    return (
        <div className="SubNavigation">
            <div className="SubButtonWrapper">
                {subButtons}
            </div>
        </div>
    )
}

export default subNavigation;


// WEBPACK FOOTER //
// ./src/components/DepartmentModule/SubNavigation/SubNavigation.js